<template>
  <v-app>
    <Header ref="header"/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-right xs12>
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentUser" style="padding-bottom: 0 !important; width: 250px; float: left;"></v-text-field>
            <div style="float: left; margin: 2px 35px;" v-if="!currentUser">
              <v-select :items="roles" v-model="filterRoles" multiple item-text="label" item-value="value" prepend-icon="fa-building" class="icon-building"/>
            </div>

            <v-btn flat v-if="currentUser && currentUser.id > 0 && !currentUser.admin" @click="impersonate" class="bw-4" style="float: left;">Impersonate</v-btn>
            <v-btn flat v-if="!currentUser" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentUser" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentUser" @click="editNewUser" class="bw-6">Create new user</v-btn>
            <v-btn flat v-if="currentUser" :disabled="saveButtonDisabled" v-on:click="save" class="bw-3">{{ currentUser.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentUser" v-show="currentUser.id > 0" @click="confirmResetPasswordDialog = true" class="bw-5">Reset password</v-btn>
            <v-btn flat v-if="canDelete" @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentUser" @click="cancel" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentUser" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredUsers" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click.exact="selectRow(props.item)" @click.alt="impersonateUser(props.item)" class="selectable">
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.userName }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.fullName }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.admin ? 'Yes' : 'No' }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.sessionCreated }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.sessionUpdated }}</td>
                  <td class="text-xs-left">{{ legalEntitiesToString(props.item.legalEntities) }}</td>
                  <td class="text-xs-left">{{ pickupAddressesToString(props.item.pickupAddresses) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <Panel v-if="currentUser">
        <PanelColumn title="User profile">
          <v-flex xs4 sm3 md3>
            <v-label>User name</v-label>
          </v-flex>
          <v-flex xs6 sm6 md4>
            <v-text-field color="teal" :readonly="currentUser.id > 0" v-model="currentUser.userName" ref="userName" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs2 sm3 md5/>

          <v-flex xs4 sm3 md3>
            <v-label>Full name</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6>
            <v-text-field color="teal" v-model="currentUser.fullName" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md3/>

          <v-flex xs4 sm3 md3>
            <v-label>E-mail</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6>
            <v-text-field color="teal" v-model="currentUser.email" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md3/>

          <v-flex xs4 sm3 md3>
            <v-label>Administrator</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6>
            <v-checkbox color="teal" v-model="currentUser.admin"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3/>

          <v-flex xs4 sm3 md3>
            <v-label>Inactive</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6>
            <v-checkbox color="teal" v-model="currentUser.inactive"/>
          </v-flex>
          <v-flex xs0 md3/>

          <v-flex xs4 sm3 md3 v-if="!(currentUser && currentUser.admin)">
            <v-label>Show quality</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="!(currentUser && currentUser.admin)">
            <v-checkbox color="teal" v-model="currentUser.showQuality"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="!(currentUser && currentUser.admin)"/>

          <v-flex xs4 sm3 md3 v-if="!(currentUser && currentUser.admin)">
            <v-label>Forecast</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="!(currentUser && currentUser.admin)">
            <v-checkbox color="teal" v-model="currentUser.forecast"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="!(currentUser && currentUser.admin)"/>

          <v-flex xs4 sm3 md3 v-if="!(currentUser && currentUser.admin)">
            <v-label>Labeller</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="!(currentUser && currentUser.admin)">
            <v-checkbox color="teal" v-model="currentUser.labeller"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="!(currentUser && currentUser.admin)"/>

          <v-flex xs4 sm3 md3 v-if="!(currentUser && currentUser.admin)">
            <v-label>Repackaging</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="!(currentUser && currentUser.admin)">
            <v-checkbox color="teal" v-model="currentUser.repackaging"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="!(currentUser && currentUser.admin)"/>

          <v-flex xs4 sm3 md3 v-if="!(currentUser && currentUser.admin)">
            <v-label>Stock list</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="!(currentUser && currentUser.admin)">
            <v-checkbox color="teal" v-model="currentUser.stockList"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="!(currentUser && currentUser.admin)"/>

          <v-flex xs4 sm3 md3 v-if="!(currentUser && currentUser.admin)">
            <v-label>Time registration</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="!(currentUser && currentUser.admin)">
            <v-checkbox color="teal" v-model="currentUser.timeRegistration"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="!(currentUser && currentUser.admin)"/>

          <v-flex xs4 sm3 md3 v-if="currentUser && !currentUser.admin && legalEntities.length > 0">
            <v-label>Company</v-label>
          </v-flex>
          <v-flex xs8 sm9 md9 v-if="currentUser && !currentUser.admin && legalEntities.length > 0">
            <v-select
              v-model="currentUser.legalEntities"
              :items="legalEntities"
              :menu-props="{ maxHeight: '300' }"
              item-text="nameAndType"
              multiple
              return-object
            ></v-select>
          </v-flex>

          <v-flex xs4 sm3 md3 v-if="currentUser && !currentUser.admin && pickupAddresses.length > 0">
            <v-label>Loading address</v-label>
          </v-flex>
          <v-flex xs8 sm9 md9 v-if="currentUser && !currentUser.admin && pickupAddresses.length > 0">
            <v-select
              v-model="currentUser.pickupAddresses"
              :items="pickupAddresses"
              :menu-props="{ maxHeight: '300' }"
              item-text="text"
              multiple
              return-object
            ></v-select>
          </v-flex>

          <v-flex xs4 sm3 md3 v-if="displayPalletNumberSequence">
            <v-label>Pallet number sequence</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="displayPalletNumberSequence">
            <v-text-field v-model="currentUser.palletNumberSequence" style="max-width: 100px;" class="right-align"></v-text-field>
          </v-flex>
          <v-flex xs0 md3 v-if="displayPalletNumberSequence"/>

          <v-flex xs4 sm3 md3 v-if="displayCreatePallet">
            <v-label>Create pallet</v-label>
          </v-flex>
          <v-flex xs8 sm9 md6 v-if="displayCreatePallet">
            <v-checkbox color="teal" v-model="currentUser.createPallet"></v-checkbox>
          </v-flex>
          <v-flex xs0 md3 v-if="displayCreatePallet"/>

          <v-flex xs4 sm3 md3 v-if="currentUser.admin">
            <v-label>Signature</v-label>
          </v-flex>
          <v-flex xs8 sm9 md9 v-if="currentUser.admin">
            <v-btn flat class="bw-4" @click='selectSignature' style="margin-left: 0;">{{ hasSignature || hasNewSignature ? 'Change' : 'Select' }}</v-btn>
            <v-btn flat class="bw-4" @click='deleteSignature' style="margin-left: 0;" v-if="hasSignature || hasNewSignature">Delete</v-btn>
            <v-spacer style="height: 5px;"></v-spacer>
            <div style="width: 256px; height: 70px; border: 1px dashed #BBBBBB; border-radius: 4px; padding: 5px 10px;" v-if="hasNewSignature || hasSignature">
              <div style="margin-top: 5px; margin-bottom: -30px; height: 50px;">
                <img :src="currentUser.signature" style="width: 100%; height: 100%; object-fit: contain;" v-if="hasNewSignature"/>
                <img :src="completeSignatureUrl" style="width: 100%; height: 100%; object-fit: contain;" v-if="hasSignature"/>
              </div>
              <div style="width: 100%; display: inline-block; border-top: 1px solid #505050;"></div>
            </div>
            <input type="file" style="display: none" ref="signature" accept=".png, .jpg, .jpeg" @change="onSignaturePicked"/>
          </v-flex>

        </PanelColumn>
      </Panel>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmResetPasswordDialog" persistent width="450">
      <v-card pa-5>
        <v-card-title class="headline">Reset password</v-card-title>
        <v-card-text v-if="currentUser">Are you sure you want to reset the password for '{{ currentUser.userName }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.resetPassword">Yes</v-btn>
          <v-btn flat @click="confirmResetPasswordDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete user</v-card-title>
        <v-card-text v-if="currentUser">Are you sure you want to delete '{{ currentUser.userName }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import NumberUtil from '@/assets/javascript/numberutil'
import axios from 'axios'

export default {
  name: 'Users',
  components: { Header, Sidebar, Footer, Panel, PanelColumn },
  data () {
    return {
      search: '',
      filterRoles: [],
      headers: [
        { text: 'User name', value: 'userName', sortable: true },
        { text: 'Name', value: 'fullName', sortable: true },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Administrator', value: 'admin', sortable: false },
        { text: 'Logged in', value: 'sessionCreated', sortable: false },
        { text: 'Last update', value: 'sessionUpdated', sortable: false },
        { text: 'Company', value: 'legalEntities', sortable: false },
        { text: 'Loading address', value: 'pickupAddresses', sortable: false }
      ],
      currentUser: null,
      palletNumberSequence: null,
      confirmDeleteDialog: false,
      confirmResetPasswordDialog: false,
      legalEntities: [],
      pickupAddresses: [],
      filterInactive: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'users' })
    this.$store.dispatch('user/loadUsers')
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentUser || this.currentUser.userName.trim() === '' || this.currentUser.fullName.trim() === '' || this.currentUser.email.trim() === '' ||
        (this.displayPalletNumberSequence && !NumberUtil.isZeroOrPositiveInteger(this.currentUser.palletNumberSequence))
    },
    canDelete: function () {
      return this.currentUser && this.currentUser.id > 0 && this.currentUser.userName !== this.$store.state.session.userName
    },
    displayCreatePallet: function () {
      if (!(this.currentUser && this.currentUser.admin) && this.currentUser.legalEntities && this.currentUser.legalEntities.length > 0) {
        for (let legalEntity of this.currentUser.legalEntities) {
          if (legalEntity.type === 'supplier') {
            return true
          } else if (legalEntity.type === 'contractor') {
            return true
          }
        }
      }
      return false
    },
    displayPalletNumberSequence: function () {
      if (this.currentUser && !this.currentUser.admin && this.currentUser.legalEntities && this.currentUser.legalEntities.length > 0) {
        for (let legalEntity of this.currentUser.legalEntities) {
          if (legalEntity.type === 'contractor') {
            return true
          }
        }
      }
      return false
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredUsers () {
      return this.users.filter(c => {
        let ok = this.filterInactive ? c.inactive : !c.inactive
        if (this.filterRoles && this.filterRoles.length) {
          if (c.legalEntities && c.legalEntities.length) {
            ok = c.legalEntities.filter(le => this.filterRoles.includes(le.type)).length
          } else {
            ok = false
          }
        }
        return ok
      })
    },
    roles () {
      let roles = []
      roles.push({ label: 'Carrier', value: 'carrier' })
      roles.push({ label: 'Contractor', value: 'contractor' })
      roles.push({ label: 'Loader', value: 'loader' })
      roles.push({ label: 'Supplier', value: 'supplier' })
      return roles
    },
    hasSignature: function () {
      return this.currentUser && this.currentUser.signature != null && this.currentUser.signature !== '' && this.currentUser.signature !== 'x' && !this.currentUser.signature.startsWith('data:')
    },
    hasNewSignature: function () {
      return this.currentUser && this.currentUser.signature != null && this.currentUser.signature !== '' && this.currentUser.signature.startsWith('data:')
    },
    completeSignatureUrl: function () {
      return this.hasSignature ? '/backend/image/' + this.currentUser.signature : ''
    }
  },
  methods: {
    selectRow (item) {
      for (let u of this.users) {
        if (u.id === item.id) {
          this.currentUser = u
          this.palletNumberSequence = u.palletNumberSequence
          break
        }
      }
      this.loadLegalEntities()
      this.loadPickupAddresses()
      // console.log('The current user is: ' + this.currentUser.userName)
    },
    editNewUser () {
      // console.log('Edit a new user')
      this.currentUser = {
        id: 0,
        userName: '',
        fullName: '',
        email: '',
        admin: false,
        repackaging: false,
        labeller: false,
        timeRegistration: false,
        stockList: false,
        forecast: false,
        createPallet: false,
        showQuality: false,
        palletNumberSequence: null
      }
      this.loadLegalEntities()
      this.loadPickupAddresses()
      this.$nextTick(() => this.$refs.userName.focus())
    },
    save () {
      // console.log('Save the user')
      if (this.currentUser.palletNumberSequence === this.palletNumberSequence) {
        // Make sure not to force an update of the pallet number sequence
        this.currentUser.palletNumberSequence = null
      }
      this.$store.dispatch('user/saveUser', this.currentUser)
        .then((response) => {
          // console.log('User saved: ' + response)
          // console.log('User display name is: ' + this.$store.state.session.fullName)
          // this.$router.push({name: 'Main'})
          // this.$refs.header.showSnackbar('Changes have been saved')
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
          // this.loginError = error.message
        })
      this.currentUser = null
    },
    resetPassword () {
      this.confirmResetPasswordDialog = false
      this.$store.dispatch('user/resetPassword', this.currentUser)
        .then((response) => {
          // console.log('Password reset: ' + response)
          this.$refs.header.showSnackbar('Password has been reset')
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
      this.currentUser = null
    },
    delete () {
      // console.log('Delete user: ' + this.currentUser.userName)
      this.$store.dispatch('user/deleteUser', this.currentUser)
        .then((response) => {
          // console.log(response)
          // console.log('User display name is: ' + this.$store.state.session.fullName)
          // this.$router.push({name: 'Main'})
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
          // this.loginError = error.message
        })

      this.confirmDeleteDialog = false
      this.currentUser = null
    },
    impersonate () {
      this.impersonateUser(this.currentUser)
    },
    impersonateUser (user) {
      if (!user.admin) {
        this.$store.dispatch('session/impersonate', user)
          .then((response) => {
            console.log('Impersonate response: ' + response)
            this.$store.dispatch('page/setSidebarItem', { key: 'dashboard' })
            this.$router.push({name: 'Main'})
          })
          .catch((error) => {
            console.log('Error: \'' + error.message + '\'')
          })
      }
    },
    cancel () {
      // console.log('Cancel the user')
      this.currentUser = null
    },
    loadLegalEntities () {
      // console.log('Loading legal entities')
      axios.get('/backend/rest/legal_entity')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.legalEntities = response.data
        })
    },
    loadPickupAddresses () {
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          this.pickupAddresses = response.data
          this.pickupAddresses.sort(function (pa1, pa2) {
            return pa1.text.toLowerCase().localeCompare(pa2.text.toLowerCase())
          })
        })
    },
    legalEntitiesToString (legalEntities) {
      if (legalEntities && legalEntities.length > 0) {
        let s = ''
        for (let le of legalEntities) {
          if (s !== '') {
            s += ', '
          }
          s += le.nameAndType
        }
        return s
      }
      return ''
    },
    pickupAddressesToString (pickupAddresses) {
      if (pickupAddresses && pickupAddresses.length > 0) {
        let s = ''
        for (let pa of pickupAddresses) {
          if (s !== '') {
            s += ', '
          }
          s += pa.text
        }
        return s
      }
      return ''
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    },
    selectSignature () {
      this.$refs.signature.click()
    },
    onSignaturePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        let imageName = files[0].name
        if (imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.currentUser.signature = fr.result
        })
      }
    },
    deleteSignature () {
      this.currentUser.signature = 'x'
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .v-input__slot {
    height: 200px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Users.vue